module.exports = __webpack_public_path__ + "static/media/unpublish.be061cbd.svg";